var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"dark":"","color":"black"}},[_c('v-toolbar-side-icon'),_c('v-toolbar-title',[_vm._v("Home")]),_c('v-spacer'),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("more_vert")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }